import * as angular from 'angular';

"use strict";
angular.module('app', []);

export default 'app';
